<template>
  <nav class="navbar is-fixed-top">
    <div class="container">
      <div class="navbar-brand">
        <a class="navbar-item is-size-3 logo">
          <b>CINE</b>FLICK
        </a>
        <div
          :class="{ 'is-active': isMenuActive }"
          class="navbar-burger burger"
          @click="isMenuActive = !isMenuActive">
          <span/>
          <span/>
          <span/>
        </div>
      </div>

      <div
        :class="{ 'is-active': isMenuActive }"
        class="navbar-menu"
        @click="isMenuActive = !isMenuActive">
        <div
          v-scroll-spy-active="{selector: 'a.navbar-item', class: 'is-active'}"
          v-scroll-spy-link="{selector: 'a.navbar-item'}"
          class="navbar-end">
          <a
            class="navbar-item">
            Cartelera
          </a>
          <a class="navbar-item">
            Estrenos
          </a>
          <a class="navbar-item">
            Snacks
          </a>
          <a class="navbar-item">
            Contacto
          </a>
          <div class="navbar-item">
            <div class="field is-grouped">
              <p class="control">
                <a
                  href="https://wa.me/50231675237"
                  target="_blank"
                  class="button whatsapp">
                  <span class="icon">
                    <WhatsAppIcon/>
                  </span>
                </a>
              </p>
              <p class="control">
                <a
                  href="https://waze.com/ul/h9fxe5muwg"
                  target="_blank"
                  class="button waze">
                  <span class="icon">
                    <WazeIcon/>
                  </span>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import WhatsAppIcon from '!vue-svg-loader!../assets/whatsapp-icon.svg'; // eslint-disable-line import/no-webpack-loader-syntax
import WazeIcon from '!vue-svg-loader!../assets/waze-icon.svg'; // eslint-disable-line import/no-webpack-loader-syntax

export default {
  name: 'Navigation',
  components: {
    WhatsAppIcon,
    WazeIcon,
  },
  data() {
    return {
      isMenuActive: false,
    };
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/functions";
@import "~@/sass/variables";

.navbar {
  .container  {
    max-width: 100%;
    padding: 0% 4%;
  }

  .navbar-burger {
    height: 4rem;
    width: 4rem;
    color: findColorInvert($dark-cyan);

    span {
      height: 2px;
      left: calc(50% - 11px);
      width: 22px;

      &:nth-child(1) {
        top: calc(50% - 8px);
      }

      &:nth-child(2) {
        top: calc(50% - 2px);
      }

      &:nth-child(3) {
        top: calc(50% + 4px);
      }
    }
    // Modifers
    &.is-active {
      span {
        &:nth-child(1) {
          transform: translateY(6px) rotate(45deg);
        }

        &:nth-child(3) {
          transform: translateY(-6px) rotate(-45deg);
        }
      }
    }
  }

  .navbar-menu {
    padding: 0;
  }

  .navbar-item {
    &.logo {
      font-weight: normal;

      &:hover {
        color: findColorInvert($dark-cyan);
      }
    }

    &.is-active {
      font-weight: bold;
    }
  }

  .button.whatsapp, .button.waze {
    background-color: transparent;
    border-color: transparent;
    color: #fff;

    .icon {
      svg {
        max-height: 100%;
        max-width: 100%;
        display: inline-block;
        font-size: inherit;
        height: 1.5em;
        overflow: visible;
        vertical-align: -.125em;
        width: 1.5em;
        fill: #fff;
      }
    }
  }

  .button.whatsapp {
    $whatsapp-color: #25D366;
    $whatsapp-color-invert: findColorInvert($whatsapp-color);
    $button-focus-box-shadow-size: 0 0 0 0.125em;

    &:hover,
    &.is-hovered {
      background-color: $whatsapp-color;
      border-color: transparent;
      color: $whatsapp-color-invert;
    }

    &:focus,
    &.is-focused {
      background-color: darken($whatsapp-color, 2.5%);
      border-color: transparent;
      color: $whatsapp-color-invert;

      &:not(:active) {
        box-shadow: $button-focus-box-shadow-size rgba($whatsapp-color, 0.25);
      }
    }

    &:active,
    &.is-active {
      background-color: darken($whatsapp-color, 5%);
      border-color: transparent;
      color: $whatsapp-color-invert;
    }
  }

  .button.waze {
    $waze-color: #25a8d8;
    $waze-color-invert: findColorInvert($waze-color);
    $button-focus-box-shadow-size: 0 0 0 0.125em;

    &:hover,
    &.is-hovered {
      background-color: $waze-color;
      border-color: transparent;
      color: $waze-color-invert;
    }

    &:focus,
    &.is-focused {
      background-color: darken($waze-color, 2.5%);
      border-color: transparent;
      color: $waze-color-invert;

      &:not(:active) {
        box-shadow: $button-focus-box-shadow-size rgba($waze-color, 0.25);
      }
    }

    &:active,
    &.is-active {
      background-color: darken($waze-color, 5%);
      border-color: transparent;
      color: $waze-color-invert;
    }
  }
}

</style>
